var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGameLostForm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    fill: "url(#paint0_linear_1854_24538)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1854_24538)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1854_24538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6578 9.22285C21.3569 7.8641 20.0397 6.61941 18.6772 6.35504C17.8472 6.1891 15.5316 5.9841 14 6.00098C12.4684 5.9841 10.1528 6.1891 9.32281 6.35504C7.96031 6.61941 6.64312 7.8641 6.34219 9.22285C6.17094 10.0479 6.0025 11.1704 6 12.7025C6.0025 14.2347 6.17094 15.3569 6.34219 16.1819C6.64312 17.5407 7.96031 18.7854 9.32281 19.0497C9.77094 19.1394 10.6522 19.2404 11.6094 19.3116C11.7178 19.4819 11.8353 19.6632 11.9625 19.8554C12.4703 20.6244 12.8591 21.1604 13.1534 21.5338C13.6434 22.1554 14.3569 22.1554 14.8469 21.5338C15.1413 21.1604 15.5297 20.6244 16.0378 19.8554C16.165 19.6629 16.2822 19.4819 16.3909 19.3116C17.3481 19.2404 18.2294 19.1394 18.6778 19.0497C20.0403 18.7854 21.3575 17.5407 21.6584 16.1819C21.8297 15.3569 21.9981 14.2347 22.0006 12.7025C21.9981 11.1704 21.8297 10.0482 21.6584 9.22317L21.6578 9.22285ZM14.8834 17.3479C14.8497 17.5382 14.6772 17.7107 14.4869 17.7444C14.3716 17.7635 14.2144 17.7816 13.9997 17.7819C13.7853 17.7819 13.6281 17.7638 13.5125 17.7444C13.3222 17.7107 13.1497 17.5382 13.1159 17.3479C13.0969 17.2325 13.0787 17.0754 13.0784 16.8607C13.0784 16.6463 13.0966 16.4891 13.1159 16.3735C13.1497 16.1832 13.3222 16.0107 13.5125 15.9769C13.6278 15.9579 13.785 15.9397 13.9997 15.9394C14.2141 15.9394 14.3712 15.9575 14.4869 15.9769C14.6772 16.0107 14.8497 16.1832 14.8834 16.3735C14.9025 16.4888 14.9206 16.646 14.9209 16.8607C14.9209 17.075 14.9028 17.2322 14.8834 17.3479ZM16.7859 12.2294C16.5447 12.5707 16.1831 12.8822 15.6481 13.2094C14.9709 13.6269 14.8625 13.7985 14.8625 14.1344V14.2672C14.8625 14.7435 14.475 15.131 13.9988 15.131C13.5225 15.131 13.135 14.7435 13.135 14.2672V13.9594C13.135 13.5632 13.2341 13.2269 13.4378 12.9316C13.6353 12.6454 13.9313 12.391 14.3703 12.13C15.1794 11.6541 15.3275 11.3869 15.3275 11.0322C15.3275 10.5866 14.9478 10.2985 14.3606 10.2985C13.7169 10.2985 13.2978 10.591 13.115 11.1682C12.9944 11.5488 12.6419 11.8044 12.2381 11.8044C12.2156 11.8044 12.1931 11.8035 12.1706 11.8019C11.8856 11.7813 11.6303 11.6335 11.4703 11.3963C11.3119 11.1616 11.2703 10.8732 11.3562 10.6047C11.5531 9.99098 11.9306 9.48035 12.4478 9.12785C12.9716 8.77098 13.6331 8.58254 14.3603 8.58254C15.0875 8.58254 15.8166 8.82348 16.3341 9.26098C16.8666 9.71129 17.16 10.3319 17.16 11.0091C17.16 11.4741 17.0378 11.8735 16.7859 12.2294Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1854_24538",
    x1: 14,
    y1: 0,
    x2: 14,
    y2: 29.1546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9027E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58297B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1854_24538"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(6 6)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1854_24538"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameLostForm);
export default __webpack_public_path__ + "static/media/game-lost-form.c8811497097868ac3f155238e8571388.svg";
export { ForwardRef as ReactComponent };